import React, { useState } from "react";
import axios from "axios";
import { toast } from "react-toastify";

const XenditCardForm = ({ orderId, amount, onBack }) => {
  const [form, setForm] = useState({
    number: "",
    expiry: "",
    cvv: "",
    firstName: "",
    lastName: "",
  });

  const [errors, setErrors] = useState({});
  const [loading, setLoading] = useState(false);

  /* ---------------- FORMAT HANDLERS ---------------- */

  const handleCardNumber = (e) => {
    let value = e.target.value.replace(/\D/g, "");
    if (value.length > 16) value = value.slice(0, 16);
    value = value.replace(/(\d{4})(?=\d)/g, "$1 ");
    setForm({ ...form, number: value });
  };

  const handleExpiry = (e) => {
    let value = e.target.value.replace(/\D/g, "");
    if (value.length > 4) value = value.slice(0, 4);

    if (value.length >= 3) {
      value = value.slice(0, 2) + "/" + value.slice(2);
    }

    setForm({ ...form, expiry: value });
  };

  const handleCVV = (e) => {
    let value = e.target.value.replace(/\D/g, "");
    if (value.length > 4) value = value.slice(0, 4);
    setForm({ ...form, cvv: value });
  };

  /* ---------------- VALIDATION ---------------- */

  const validate = () => {
    let e = {};

    const cardNumber = form.number.replace(/\s/g, "");

    // Luhn check
    const luhnCheck = (num) => {
      let sum = 0;
      let shouldDouble = false;

      for (let i = num.length - 1; i >= 0; i--) {
        let digit = parseInt(num[i]);

        if (shouldDouble) {
          digit *= 2;
          if (digit > 9) digit -= 9;
        }

        sum += digit;
        shouldDouble = !shouldDouble;
      }

      return sum % 10 === 0;
    };

    if (!/^\d{16}$/.test(cardNumber) || !luhnCheck(cardNumber)) {
      e.number = "Invalid card number";
    }

    if (!/^\d{2}\/\d{2}$/.test(form.expiry)) {
      e.expiry = "Invalid expiry";
    } else {
      const [mm] = form.expiry.split("/");
      const month = parseInt(mm);
      if (month < 1 || month > 12) {
        e.expiry = "Invalid month";
      }
    }

    if (!/^\d{3,4}$/.test(form.cvv)) {
      e.cvv = "Invalid CVV";
    }

    if (!form.firstName.trim()) {
      e.firstName = "First name required";
    }

    if (!form.lastName.trim()) {
      e.lastName = "Last name required";
    }

    setErrors(e);
    return Object.keys(e).length === 0;
  };

  /* ---------------- SUBMIT ---------------- */

  const submit = async (e) => {
    e.preventDefault();

    if (!validate()) return;

    setLoading(true);

    try {
      await axios.post(`${window.BASE_API_URL}xendit/card-pay`, {
        orderId,
        amount,
        card: form,
      });

      toast.success("Payment initiated");
    } catch {
      toast.error("Payment failed");
    }

    setLoading(false);
  };

  return (
    <form onSubmit={submit} className="space-y-5">

      {/* CARD NUMBER */}
      <input
        placeholder="1234 5678 9012 3456"
        value={form.number}
        onChange={handleCardNumber}
        maxLength={19}
        className="input"
      />
      {errors.number && <p className="text-red-500 text-sm">{errors.number}</p>}

      {/* EXPIRY + CVV */}
      <div className="flex gap-3">
        <div className="w-1/2">
          <input
            placeholder="MM/YY"
            value={form.expiry}
            onChange={handleExpiry}
            maxLength={5}
            className="input"
          />
          {errors.expiry && <p className="text-red-500 text-sm">{errors.expiry}</p>}
        </div>

        <div className="w-1/2">
          <input
            placeholder="CVV"
            value={form.cvv}
            onChange={handleCVV}
            maxLength={4}
            className="input"
          />
          {errors.cvv && <p className="text-red-500 text-sm">{errors.cvv}</p>}
        </div>
      </div>

      {/* FIRST + LAST NAME */}
      <div className="flex gap-3">
        <div className="w-1/2">
          <input
            placeholder="First Name"
            value={form.firstName}
            onChange={(e) =>
              setForm({ ...form, firstName: e.target.value })
            }
            className="input"
          />
          {errors.firstName && (
            <p className="text-red-500 text-sm">{errors.firstName}</p>
          )}
        </div>

        <div className="w-1/2">
          <input
            placeholder="Last Name"
            value={form.lastName}
            onChange={(e) =>
              setForm({ ...form, lastName: e.target.value })
            }
            className="input"
          />
          {errors.lastName && (
            <p className="text-red-500 text-sm">{errors.lastName}</p>
          )}
        </div>
      </div>

      {/* BUTTONS */}
      <div className="flex gap-3">
        <button type="button" onClick={onBack} className="btn-secondary">
          Back
        </button>

        <button type="submit" disabled={loading} className="btn-primary">
          {loading ? "Processing..." : `Pay ₹${amount}`}
        </button>
      </div>
    </form>
  );
};

export default XenditCardForm;